import { configureStore } from "@reduxjs/toolkit";
import createSagaMiddleware from "redux-saga";
import rootSaga from "src/saga";
import metadataSlice from "src/slices/metadataSlice";
import reservationList from "src/slices/reservationList";
import resale from "src/slices/resale";

const sagaMiddleware = createSagaMiddleware();
export const store = configureStore({
  reducer: {
    metadata: metadataSlice,
    reservationList,
    resale,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ serializableCheck: false }).concat(sagaMiddleware),
});

sagaMiddleware.run(rootSaga);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
